/* eslint-disable no-shadow */
import React, { useState } from 'react'
import {
  Dialog,
  Typography,
  DialogContent,
  DialogActions,
  FormHelperText,
  CircularProgress,
  FormControlLabel,
  DialogContentText,
  Paper,
} from '@material-ui/core'
import Button from 'src/components/sharedComponents/CustomButtons/Button'
import { Autocomplete } from '@material-ui/lab'
import MultiSelect from 'src/components/sharedComponents/Multiselect/Multiselect'
import {
  isNitValid,
  isCodeValid,
  isPhoneValid,
  isEmailValid,
} from 'src/utils/inputValidations'
import {
  useStyles,
  OrangeSwitch,
  OrangeCheckbox,
  OrangeTextField,
} from './styles'

const initialError = {
  nit: '',
  code: '',
  email: '',
  phone: '',
  telephone: '',
}

const EstablecimientosAdd = (props) => {
  const {
    form,
    vertical,
    isEdit,
    loading,
    onClose,
    controls,
    ciudades,
    vehiculos,
    handleSubmit,
    onChangeInputs,
    openAddToSocio,
  } = props

  const [inputsStates, setInputsStates] = useState({
    inputCiudad: '',
    inputVehiculos: '',
    inputSucursal: '',
    inputTestDrive: '',
  })

  const [error, setError] = useState(initialError)
  const disabled =
    error.code !== '' ||
    error.nit !== '' ||
    error.phone !== '' ||
    error.email !== '' ||
    error.telephone !== ''

  const classes = useStyles()
  const createTitle =
    'Cree un Establecimiento para agregarlo a la lista y relacionarlo con las reglas de leads.'
  const editTitle =
    'Edite un socio comercial, los cambios que realice no se podrán recuperar '

  const onChangeinputValue = (newValue, field) => {
    setInputsStates({ ...inputsStates, [field]: newValue })
  }
  const filteredCiudades = ciudades.filter(
    (ciudad) =>
      ciudad.NOMBRE_MPI.includes(
        inputsStates.inputSucursal.toLocaleUpperCase(),
      ) ||
      ciudad.NOMBRE_DPT.includes(
        inputsStates.inputSucursal.toLocaleUpperCase(),
      ),
  )
  const filteredVehiculos = vehiculos.filter((vehiculo) =>
    vehiculo.linea.includes(
      inputsStates.inputVehiculos.toLocaleUpperCase() ||
        inputsStates.inputTestDrive.toLocaleUpperCase(),
    ),
  )

  return (
    <>
      <Dialog
        open={openAddToSocio}
        onClose={onClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Typography className={classes.mainTitle}>
          {isEdit ? 'Editar Establecimiento' : 'Agregar Establecimiento'}
        </Typography>
        <DialogContent>
          <DialogContentText>
            {isEdit ? editTitle : createTitle}
          </DialogContentText>
          <form action="/" onSubmit={handleSubmit}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}
            >
              <FormControlLabel
                label="Estado"
                control={
                  <OrangeSwitch
                    checked={Boolean(Number(form.estado))}
                    onChange={(e) => {
                      const isActive = e.target.checked ? 1 : 0
                      onChangeInputs(isActive, 'estado')
                    }}
                  />
                }
              />
              <div className={classes.scoreContainer}>
                <OrangeTextField
                  label="Puntaje"
                  type="number"
                  value={form.score ?? ''}
                  inputProps={{ step: 0.01, min: 0, max: 1 }}
                  onChange={(event) => onChangeInputs(event.target.value, 'score')}
                />
              </div>
            </div>
            <div>
              <OrangeTextField
                fullWidth
                value={form.razon_comercial || ''}
                onChange={(event) =>
                  onChangeInputs(event.target.value, 'razon_comercial')
                }
                required
                id="razon_comercial"
                name="razon_comercial"
                label="Razón Comercial"
              />
            </div>
            <div>
              <OrangeTextField
                fullWidth
                value={form.nombre_establecimiento || ''}
                onChange={(event) =>
                  onChangeInputs(event.target.value, 'nombre_establecimiento')
                }
                required
                id="nombre_establecimiento"
                name="nombre_establecimiento"
                label="Nombre Establecimiento"
              />
            </div>
            <div>
              <OrangeTextField
                error={error.nit}
                fullWidth
                value={form.nit || ''}
                required
                id="nit"
                name="nit"
                label="NIT"
                onChange={(event) => {
                  const isValid = isNitValid(event.target.value)
                  if (!isValid) {
                    setError({ ...error, nit: 'Nit inválido' })
                  } else {
                    setError({ ...error, nit: '' })
                  }
                  onChangeInputs(event.target.value, 'nit')
                }}
              />
              <FormHelperText error>{error.nit}</FormHelperText>
            </div>

            <div>
              <OrangeTextField
                fullWidth
                required
                error={error.code}
                value={form.codigo_destinatario || ''}
                onChange={(event) => {
                  const isValid = isCodeValid(event.target.value)
                  if (!isValid) {
                    setError({ ...error, code: 'Código inválido' })
                  } else {
                    setError({ ...error, code: '' })
                  }
                  onChangeInputs(event.target.value, 'codigo_destinatario')
                }}
                id="codigo_destinatario"
                name="codigo_destinatario"
                label="Código destinatario"
              />
              <FormHelperText error>{error.code}</FormHelperText>
            </div>

            <div>
              <OrangeTextField
                error={error.email}
                fullWidth
                value={form.correo_electronico || ''}
                onChange={(event) => {
                  const isValid = isEmailValid(event.target.value)
                  if (!isValid) {
                    setError({ ...error, email: 'Email inválido' })
                  } else {
                    setError({ ...error, email: '' })
                  }
                  onChangeInputs(event.target.value, 'correo_electronico')
                }}
                required
                id="correo_electronico"
                name="correo_electronico"
                label="Correo Electrónico"
                type="email"
              />
              <FormHelperText error>{error.email}</FormHelperText>
            </div>

            <div>
              <OrangeTextField
                error={error.telephone}
                fullWidth
                value={form.telefono_fijo || ''}
                onChange={(event) => {
                  const isValid = isPhoneValid(event.target.value)
                  if (!isValid) {
                    setError({ ...error, telephone: 'telefono inválido' })
                  } else {
                    setError({ ...error, telephone: '' })
                  }
                  onChangeInputs(event.target.value, 'telefono_fijo')
                }}
                required
                id="telefono"
                name="telefono"
                label="Teléfono Fijo"
              />
              <FormHelperText error>{error.telephone}</FormHelperText>
            </div>

            <div>
              <OrangeTextField
                error={error.phone}
                value={form.celular || ''}
                fullWidth
                onChange={(event) => {
                  const isValid = isPhoneValid(event.target.value)
                  if (!isValid) {
                    setError({ ...error, phone: 'Celular inválido' })
                  } else {
                    setError({ ...error, phone: '' })
                  }
                  onChangeInputs(event.target.value, 'celular')
                }}
                required
                id="celular"
                name="celular"
                label="Celular"
              />
              <FormHelperText error>{error.phone}</FormHelperText>
            </div>
            <div>
              <Autocomplete
                value={controls.ciudadControl}
                onChange={(event, newValue) => {
                  onChangeInputs(newValue, 'ciudad')
                }}
                inputValue={inputsStates.inputCiudad || ''}
                onInputChange={(event, newInputValue) => {
                  setInputsStates({
                    ...inputsStates,
                    inputCiudad: newInputValue,
                  })
                }}
                id="ciudad"
                getOptionSelected={(e) =>
                  e.label === controls.ciudadControl.label
                }
                options={ciudades.map((ciudad) => ({
                  label: `${ciudad.NOMBRE_MPI} (${ciudad.NOMBRE_DPT})`,
                  value: ciudad.NOMBRE_MPI,
                  value2: ciudad.NOMBRE_DPT,
                }))}
                renderInput={(params) => (
                  <OrangeTextField
                    required
                    {...params}
                    label="Ciudad Principal"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: 'new-password',
                    }}
                  />
                )}
                getOptionLabel={(option) => option.label || form.ciudad}
                PaperComponent={(props) => (
                  <Paper {...props} style={{ height: '150px' }} />
                )}
              />
            </div>

            <div>
              <OrangeTextField
                value={form.direccion || ''}
                onChange={(event) =>
                  onChangeInputs(event.target.value, 'direccion')
                }
                fullWidth
                required
                id="direccion"
                name="direccion"
                label="Dirección"
              />
            </div>
            <div>
              <OrangeTextField
                value={form.horario || ''}
                fullWidth
                onChange={(event) =>
                  onChangeInputs(event.target.value, 'horario')
                }
                required
                id="horario"
                name="horario"
                label="Horario"
              />
            </div>

            <div>
              <MultiSelect
                originalArr={ciudades.map((ciudad) => ({
                  label: `${ciudad.NOMBRE_MPI} (${ciudad.NOMBRE_DPT})`,
                  value: ciudad.NOMBRE_MPI,
                  value2: ciudad.NOMBRE_DPT,
                }))}
                limitTags={4}
                items={filteredCiudades.map((ciudad) => ({
                  label: `${ciudad.NOMBRE_MPI} (${ciudad.NOMBRE_DPT})`,
                  value: ciudad.NOMBRE_MPI,
                  value2: ciudad.NOMBRE_DPT,
                }))}
                label="Ciudades que atiende"
                placeholder="Ciudades"
                selectAllLabel="Todos"
                initialValue={controls.sucursalesControl}
                onChange={(e) => {
                  onChangeInputs(e, 'establecimientoCiudades')
                }}
                inputState={inputsStates.inputSucursal}
                onChangeinputValue={(value) =>
                  onChangeinputValue(value, 'inputSucursal')
                }
              />
            </div>
            <div>
              <MultiSelect
                originalArr={
                  vehiculos
                  .filter((vehiculo) =>
                    vertical === "TVS" ? vehiculo.marca === "TVS" : vehiculo.marca !== "TVS"
                  )
                  .map((vehiculo) => ({
                  label: vehiculo.linea,
                  value: vehiculo.id,
                }))}
                limitTags={4}
                items={
                  filteredVehiculos.filter((vehiculo) =>
                    vertical === "TVS" ? vehiculo.marca === "TVS" : vehiculo.marca !== "TVS"
                  )
                  .map((vehiculo) => ({
                  label: vehiculo.linea,
                  value: vehiculo.id,
                }))}
                label="Vehículos"
                placeholder="Vehículos"
                selectAllLabel="Todos"
                initialValue={controls.vehiculosControl}
                onChange={(e) => {
                  onChangeInputs(e, 'establecimientoVehiculos')
                }}
                inputState={inputsStates.inputVehiculos}
                onChangeinputValue={(value) =>
                  onChangeinputValue(value, 'inputVehiculos')
                }
              />
            </div>
            <div>
              <MultiSelect
                originalArr={vehiculos.map((vehiculo) => ({
                  label: vehiculo.linea,
                  value: vehiculo.id,
                }))}
                limitTags={4}
                items={filteredVehiculos.map((vehiculo) => ({
                  label: vehiculo.linea,
                  value: vehiculo.id,
                }))}
                label="Test Drive"
                placeholder="Test Drive"
                selectAllLabel="Todos"
                initialValue={controls.testDriveControl}
                onChange={(e) => {
                  onChangeInputs(e, 'establecimientoTestdriveVehiculos')
                }}
                inputState={inputsStates.inputTestDrive}
                onChangeinputValue={(value) =>
                  onChangeinputValue(value, 'inputTestDrive')
                }
              />
            </div>
            <div>
              <OrangeTextField
                value={form.token_integracion || ''}
                onChange={(event) =>
                  onChangeInputs(event.target.value, 'token_integracion')
                }
                fullWidth
                required
                id="token_integracion"
                name="token_integracion"
                label="Token integración"
              />
            </div>
            {/* sadsad */}

            <FormControlLabel
              label="Financiación"
              control={
                <OrangeSwitch
                  checked={Boolean(Number(form.financiacion))}
                  onChange={(e) => {
                    const isActive = e.target.checked ? 1 : 0
                    onChangeInputs(isActive, 'financiacion')
                  }}
                />
              }
            />

            <FormControlLabel
              label="Retoma"
              control={
                <OrangeSwitch
                  checked={Boolean(Number(form.retoma))}
                  onChange={(e) => {
                    const isActive = e.target.checked ? 1 : 0
                    onChangeInputs(isActive, 'retoma')
                  }}
                />
              }
            />
            <FormControlLabel
              label="Sitio Web"
              control={
                <OrangeSwitch
                  checked={Boolean(Number(form.sitio_web_b2w))}
                  onChange={(e) => {
                    const isActive = e.target.checked ? 1 : 0
                    onChangeInputs(isActive, 'sitio_web_b2w')
                  }}
                />
              }
            />

            <FormControlLabel
              label="Equipo Digital"
              control={
                <OrangeSwitch
                  checked={Boolean(Number(form.equipo_digital))}
                  onChange={(e) => {
                    const isActive = e.target.checked ? 1 : 0
                    onChangeInputs(isActive, 'equipo_digital')
                  }}
                />
              }
            />

            <FormControlLabel
              label="Impulsa"
              control={
                <OrangeSwitch
                  checked={Boolean(Number(form.impulsa))}
                  onChange={(e) => {
                    const isActive = e.target.checked ? 1 : 0
                    onChangeInputs(isActive, 'impulsa')
                  }}
                />
              }
            />

            <div />

            <DialogActions>
              {loading ? (
                <CircularProgress />
              ) : (
                <Button
                  disabled={disabled}
                  type="submit"
                  color="warning"
                  onMouseDown={(e) => e.preventDefault()}
                >
                  Guardar
                </Button>
              )}
              <Button onClick={onClose}>Cerrar</Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default EstablecimientosAdd
